import React from 'react';
import {
  DragSource,
  DropTarget
} from 'react-dnd';
import Collapsible from '../collapsible-sub-group-listing';
import { flow } from 'lodash-es';

const ITEM_TYPE = 'children';

const dragSourceCollector = (connect, monitor, props) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

const dropTargetCollector = (connect, monitor, props) => {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
};

const dragSourceSpec = {
  beginDrag: (props) => {
    return { children: props.children };
  },
  isDragging: (props, monitor) => {
    return props.children === monitor.getItem().children;
  },
  endDrag: (props) => {
    props.onDragEnd();
  },
  canDrag: (props) => {
    return props.canDrag;
  }
};

const dropTargetSpec = {
  hover: (props, monitor, component) => {
    var target = props.children;
    var src = monitor.getItem().children;

    if (src !== target) {
      props.onDragOver(src, target);
    }
  }
};

const OrderedCollapsible = (props) => {
  const { connectDragSource, connectDropTarget, ...rest } = props;

  return connectDragSource(
    connectDropTarget(
      <div data-test-id="collapsible-card">
        <Collapsible {...rest} />
      </div>
    )
  );
};

export default flow(
  DragSource(ITEM_TYPE, dragSourceSpec, dragSourceCollector),
  DropTarget(ITEM_TYPE, dropTargetSpec, dropTargetCollector)
)(OrderedCollapsible);
